import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { StylishNewCheckbox } from 'components/DesignSystems/New/StylishNewCheckbox';

import { setCloneDefaults, fetchCloneDefaults } from 'actions/diceActions';

import { NEW_USER_DEMO_SETTER_DOMAIN } from '../../environment';

export default function CloneDefaults() {
  const reduxDispatch = useDispatch();

  const reduxCurrentIncident = useSelector((state) => {
    return state.app.currentIncident;
  });

  const reduxCurrentlySelectedGroup = useSelector((state) => {
    return state.app.currentlySelectedGroup;
  });

  const reduxCloneDefaults = useSelector((state) => {
    return state.app.cloneDefaults;
  });

  const isFetchCloneDefaultsLoaded = useSelector((state) => {
    return state.app.isFetchCloneDefaultsLoaded;
  });

  const isSetCloneDefaultsLoaded = useSelector((state) => {
    return state.app.isSetCloneDefaultsLoaded;
  });

  const user = useSelector((state) => {
    return state.app.user;
  });

  useEffect(() => {
    if (
      !!reduxCurrentIncident &&
      !!reduxCurrentIncident.id &&
      !!reduxCurrentlySelectedGroup &&
      !!reduxCurrentlySelectedGroup.group_guid &&
      !!isFetchCloneDefaultsLoaded
    ) {
      reduxDispatch(fetchCloneDefaults());
    }
  }, [reduxCurrentIncident, reduxCurrentlySelectedGroup]);

  if (
    // fix this.
    !!NEW_USER_DEMO_SETTER_DOMAIN &&
    user.email_address.split(NEW_USER_DEMO_SETTER_DOMAIN).length > 1 &&
    (!reduxCurrentIncident ||
      !reduxCurrentlySelectedGroup ||
      !reduxCloneDefaults)
  ) {
    return <div>Loading clone defaults...</div>;
  }

  return (
    <div className="CloneDefaults">
      {!!NEW_USER_DEMO_SETTER_DOMAIN &&
        user.email_address.split(NEW_USER_DEMO_SETTER_DOMAIN).length > 1 && (
          <div>
            <StylishNewCheckbox
              key={`CloneDefaults-checkbox`}
              checked={
                reduxCloneDefaults.group_guid ===
                  reduxCurrentlySelectedGroup.group_guid &&
                reduxCloneDefaults.incident_id === reduxCurrentIncident.id
              }
              disabled={
                reduxCloneDefaults.group_guid ===
                  reduxCurrentlySelectedGroup.group_guid &&
                reduxCloneDefaults.incident_id === reduxCurrentIncident.id
              }
              onClick={() =>
                reduxDispatch(
                  setCloneDefaults(
                    reduxCurrentlySelectedGroup.group_guid,
                    reduxCurrentIncident.id
                  )
                )
              }
              label={
                'The current Group and Incident are the default for new users.'
              }
            />
            {!isSetCloneDefaultsLoaded && <small>Updating defaults...</small>}
          </div>
        )}
    </div>
  );
}
